import { render, staticRenderFns } from "./lrValueToLabel.vue?vue&type=template&id=3e1ffcf4"
import script from "./lrValueToLabel.vue?vue&type=script&lang=js"
export * from "./lrValueToLabel.vue?vue&type=script&lang=js"
import style0 from "./lrValueToLabel.vue?vue&type=style&index=0&id=3e1ffcf4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports